import { useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import Drawer from '../../../../../components/common/Drawer'
import Input from '../../../../../components/form/input/InputField'
import Label from '../../../../../components/form/Label'
import { api } from '../../../../../configs/api'
import { useAuth } from '../../../../../context/AuthContext'
import { useCompany } from '../../../../../context/CompanyContext'
import { Delete } from 'lucide-react'
import DeleteButton from '../../../../../components/common/DeleteButton'
import ContactsDelete from './ContactsDelete'

export type ContactType = {
    id: number
    name: string
    image: string | null
    email: string | null
    phone: string | null
}

const ContactsForm = ({
    data,
    type,
    open,
    handleClose
}: {
    data: ContactType | null
    type: 'create' | 'edit'
    open: boolean
    handleClose: () => void
}) => {
    const { unity } = useAuth()
    const { detail, getCompany } = useCompany()
    const [openDelete, setOpenDelete] = useState(false)
    const form = useForm({ mode: 'onChange' })
    const formRef = useRef<HTMLFormElement>(null)

    const handleSave = async (value: any) => {
        if (!unity || !detail) return

        if (type === 'edit' && !detail.company.id) {
            return toast.error('Nenhuma empresa selecionada!')
        }

        try {
            const route = type === 'create' ? `${api}company/contact/create` : `${api}company/contact/update`
            const values = {
                ...value,
                id: type === 'edit' && data ? data.id : null,
                companyID: detail.company.id,
                unityID: unity.unityID
            }

            const response = await fetch(route, {
                method: 'POST',
                body: JSON.stringify(values)
            })
            const result = await response.json()
            if (!result.success || !result.company.id) return toast.error(result.message || 'Erro ao salvar contato!')

            getCompany(result.company.id)
            handleClose()
            toast.success(result.message || 'Contato salvo com sucesso!')
        } catch (error) {
            console.log(error)
        }
    }

    // Atualiza os valores do formulário quando o contexto mudar
    useEffect(() => {
        if (type === 'edit' && data) {
            form.reset({
                name: data.name || '',
                email: data.email && data.email != '--' ? data.email : '',
                phone: data.phone && data.phone != '--' ? data.phone : ''
            })
        } else if (type === 'create') {
            form.reset({
                name: '',
                email: '',
                phone: ''
            })
        }
    }, [data])

    return (
        <>
            <Drawer
                open={open}
                handleClose={handleClose}
                title={
                    type === 'create' ? (
                        'Adicionar contato'
                    ) : (
                        <div className='flex items-center gap-2'>
                            <span>Editar contato</span>
                            <DeleteButton handleClick={() => setOpenDelete(true)} />
                        </div>
                    )
                }
                handleSave={() => formRef.current?.requestSubmit()}
            >
                <form ref={formRef} onSubmit={form.handleSubmit(handleSave)}>
                    <div className='space-y-3'>
                        <div>
                            <Label required>Nome</Label>
                            <Input {...form.register('name', { required: true })} placeholder='Nome' />
                        </div>
                        <div>
                            <Label>E-mail</Label>
                            <Input {...form.register('email')} type='email' placeholder='E-mail' />
                        </div>
                        <div>
                            <Label>Telefone</Label>
                            <Input {...form.register('phone')} placeholder='Telefone' />
                        </div>
                    </div>
                </form>
            </Drawer>

            <ContactsDelete
                open={openDelete}
                handleClose={() => {
                    setOpenDelete(false)
                    handleClose()
                }}
                data={data}
            />
        </>
    )
}

export default ContactsForm
